// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "../styles/luckydraw.css";
// import {
//   getLuckyDrawUsers,
//   postLuckyDrawUser,
// } from "../services/apiService";
// import luckyDrawBg from "../assets/background.webp";

// const LuckyDraw = () => {
//   const navigate = useNavigate();

//   const [participants, setParticipants] = useState([]);

//   const [isSpinning, setIsSpinning] = useState(false);
//   const [displayNumber, setDisplayNumber] = useState("XXXXXXXXXX");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // ==========================================
//   // GET PARTICIPANTS
//   // ==========================================
//   useEffect(() => {
//     const fetchParticipants = async () => {
//       try {
//         setLoading(true);
//         setError("");

//         const result = await getLuckyDrawUsers();

//         if (result.status && Array.isArray(result.data)) {
//           setParticipants(result.data);
//         } else {
//           setParticipants([]);
//           setError("No participants found");
//         }
//       } catch (error) {
//         console.error("Error fetching lucky draw users:", error);
//         setError("Unable to load participants");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchParticipants();
//   }, []);

//   // ==========================================
//   // START LUCKY DRAW
//   // ==========================================
//   const startLuckyDraw = () => {
//     if (isSpinning || participants.length === 0) return;

//     setIsSpinning(true);

//     // Number spinning
//     const interval = setInterval(() => {
//       const randomParticipant =
//         participants[
//           Math.floor(Math.random() * participants.length)
//         ];

//       setDisplayNumber(randomParticipant.mobile);
//     }, 100);

//     // Stop after 5 seconds
//     setTimeout(async () => {
//       clearInterval(interval);

//       // ==========================================
//       // SELECT ONLY ONE WINNER
//       // ==========================================
//       const selectedWinner =
//         participants[
//           Math.floor(Math.random() * participants.length)
//         ];

//       console.log("Selected Winner:", selectedWinner);

//       setDisplayNumber(selectedWinner.mobile);

//       // ==========================================
//       // POST ONLY SELECTED WINNER
//       // ==========================================
//       const payload = {
//         mobileno: selectedWinner.mobile,
//         date: selectedWinner.date_joined,
//         name: selectedWinner.first_name,
//       };

//       console.log("Winner POST Payload:", payload);

//       try {
//         const postResult = await postLuckyDrawUser(payload);

//         console.log("Winner POST Response:", postResult);
//       } catch (error) {
//         console.error(
//           "Error posting selected winner:",
//           error
//         );
//       }

//       // ==========================================
//       // GO TO WINNER PAGE
//       // ==========================================
//       setTimeout(() => {
//         navigate("/winner-reveal", {
//           state: {
//             winner: selectedWinner,
//           },
//         });
//       }, 800);
//     }, 5000);
//   };

//   return (
//     <div
//       className="lucky-draw-page"
//       style={{
//         backgroundImage: `url(${luckyDrawBg})`,
//       }}
//     >
//       <div className="lucky-draw-card">
//         <h1>🎉 Lucky Draw 🎉</h1>

//         <p className="subtitle">
//           Click the button and discover today's lucky winner!
//         </p>

//         {loading ? (
//           <div className="number-box">
//             Loading...
//           </div>
//         ) : error ? (
//           <div className="number-box">
//             {error}
//           </div>
//         ) : (
//           <div
//             className={`number-box ${
//               isSpinning ? "spinning" : ""
//             }`}
//           >
//             {displayNumber}
//           </div>
//         )}

//         <button
//           className="draw-button"
//           onClick={startLuckyDraw}
//           disabled={
//             isSpinning ||
//             loading ||
//             participants.length === 0
//           }
//         >
//           {isSpinning
//             ? "Spinning..."
//             : "🎁 Start Lucky Draw"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default LuckyDraw;
//

import backgroundImage from "../assets/image3.png";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/luckydraw.css";
import { getLuckyDrawUsers, postLuckyDrawUser } from "../services/apiService";
import pixelLogo from "../assets/pixelwhite.png";

const BOX_COUNT = 20;
const DRAW_DURATION = 10000;

const LuckyDraw = () => {
  const navigate = useNavigate();

  // ==========================================
  // PARTICIPANTS FROM API
  // ==========================================
  const [participants, setParticipants] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ==========================================
  // DRAW STATES
  // ==========================================
  const [boxes, setBoxes] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [winner, setWinner] = useState(null);
  const [drawing, setDrawing] = useState(false);

  const timerRef = useRef(null);
  const animationRef = useRef(null);

  // ==========================================
  // GET PARTICIPANTS
  // ==========================================
  useEffect(() => {
    const fetchParticipants = async () => {
      try {
        setLoading(true);
        setError("");

        const result = await getLuckyDrawUsers();

        console.log("PARTICIPANTS RESPONSE:", result);

        if (result.status && Array.isArray(result.data)) {
          setParticipants(result.data);

          // Create initial 20 boxes
          const shuffled = [...result.data].sort(() => Math.random() - 0.5);

          const initialBoxes = Array.from(
            { length: BOX_COUNT },
            (_, index) => shuffled[index % shuffled.length],
          );

          setBoxes(initialBoxes);
        } else {
          setParticipants([]);
          setBoxes([]);
          setError("No participants found");
        }
      } catch (error) {
        console.error("Error fetching lucky draw users:", error);

        setParticipants([]);
        setBoxes([]);
        setError("Unable to load participants");
      } finally {
        setLoading(false);
      }
    };

    fetchParticipants();
  }, []);

  // ==========================================
  // CLEANUP
  // ==========================================
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  // ==========================================
  // RANDOM PARTICIPANT
  // ==========================================
  const getRandomParticipant = () => {
    if (!participants.length) {
      return null;
    }

    const randomIndex = Math.floor(Math.random() * participants.length);

    return participants[randomIndex];
  };

  // ==========================================
  // FORMAT MOBILE
  // ==========================================
  const formatMobile = (mobile) => {
    if (!mobile) {
      return "••••";
    }

    return `XXXXXX${mobile.slice(-4)}`;
  };

  // ==========================================
  // START LUCKY DRAW
  // ==========================================
  const startLuckyDraw = () => {
    if (drawing || participants.length === 0) {
      return;
    }

    setDrawing(true);
    setWinner(null);

    // ==========================================
    // SELECT ACTUAL WINNER FROM FULL API DATA
    // ==========================================
    const winnerIndex = Math.floor(Math.random() * participants.length);

    const selectedWinner = participants[winnerIndex];

    console.log("SELECTED WINNER:", selectedWinner);

    // ==========================================
    // SELECT RANDOM BOX WHERE WINNER WILL STOP
    // ==========================================
    const finalBoxIndex = Math.floor(Math.random() * BOX_COUNT);

    const startTime = Date.now();

    let previousIndex = -1;
    const animate = () => {
      const elapsed = Date.now() - startTime;

      const progress = Math.min(elapsed / DRAW_DURATION, 1);
      let nextIndex;

      do {
        nextIndex = Math.floor(Math.random() * BOX_COUNT);
      } while (nextIndex === previousIndex && BOX_COUNT > 1);

      previousIndex = nextIndex;

      setActiveIndex(nextIndex);

      setBoxes((previousBoxes) => {
        const updated = [...previousBoxes];

        let changeCount;

        if (progress < 0.35) {
          changeCount = 8;
        } else if (progress < 0.55) {
          changeCount = 6;
        } else if (progress < 0.72) {
          changeCount = 4;
        } else if (progress < 0.88) {
          changeCount = 2;
        } else {
          changeCount = 1;
        }

        for (let i = 0; i < changeCount; i++) {
          const randomPosition = Math.floor(Math.random() * BOX_COUNT);

          updated[randomPosition] = getRandomParticipant();
        }

        return updated;
      });

      // ==========================================
      // FINISH DRAW
      // ==========================================
      if (elapsed >= DRAW_DURATION) {
        // Put actual winner into final highlighted box
        setActiveIndex(finalBoxIndex);

        setBoxes((previousBoxes) => {
          const updated = [...previousBoxes];

          updated[finalBoxIndex] = selectedWinner;

          return updated;
        });

        // ==========================================
        // POST ONLY SELECTED WINNER
        // ==========================================
        const payload = {
          mobileno: selectedWinner.mobile,
          date: selectedWinner.date_joined,
          name: selectedWinner.first_name,
        };

        console.log("WINNER POST PAYLOAD:", payload);

        postLuckyDrawUser(payload)
          .then((postResult) => {
            console.log("WINNER POST RESPONSE:", postResult);
          })
          .catch((error) => {
            console.error("ERROR POSTING WINNER:", error);
          });

        // ==========================================
        // SHOW WINNER BRIEFLY
        // ==========================================
        setTimeout(() => {
          setWinner(selectedWinner);
          setDrawing(false);

          // ==========================================
          // GO TO WINNER REVEAL PAGE
          // ==========================================
          setTimeout(() => {
            navigate("/winner-reveal", {
              state: {
                winner: selectedWinner,
              },
            });
          }, 800);
        }, 700);

        return;
      }

      // ==========================================
      // RANDOM SPEED
      // ==========================================
      let delay;

      if (progress < 0.25) {
        delay = 45 + Math.random() * 35;
      } else if (progress < 0.45) {
        delay = 65 + Math.random() * 45;
      } else if (progress < 0.65) {
        delay = 90 + Math.random() * 70;
      } else if (progress < 0.8) {
        delay = 130 + Math.random() * 100;
      } else if (progress < 0.92) {
        delay = 190 + Math.random() * 130;
      } else {
        delay = 300 + Math.random() * 180;
      }

      timerRef.current = setTimeout(() => {
        animationRef.current = requestAnimationFrame(animate);
      }, delay);
    };

    animate();
  };

  // ==========================================
  // DRAW AGAIN
  // ==========================================
  const resetDraw = () => {
    if (drawing) {
      return;
    }

    setWinner(null);
    setActiveIndex(-1);

    if (!participants.length) {
      setBoxes([]);
      return;
    }

    const shuffled = [...participants].sort(() => Math.random() - 0.5);

    const newBoxes = Array.from(
      { length: BOX_COUNT },
      (_, index) => shuffled[index % shuffled.length],
    );

    setBoxes(newBoxes);
  };

  // ==========================================
  // RENDER
  // ==========================================
  return (
    <section
      className="luckydraw-container"
      style={{
        height: "auto",
        width: "auto",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* BACKGROUND DECORATION */}
      <div className="luckydraw-glow glow-one"></div>
      <div className="luckydraw-glow glow-two"></div>

      <div className="luckydraw-content">
        {/* PAGE HEADER */}
        <header className="luckydraw-header">
          <div className="pixel-logo">
            <a href="/" aria-label="Pixel India Home">
              <img src={pixelLogo} alt="Pixel India Logo" />
            </a>
          </div>
          <div>
            <p>
              <h1>Lucky Draw EVENT</h1>
              One winner. One moment. Selected fairly from all participants.
            </p>
          </div>

          <div className="luckydraw-title-area"></div>

          <div className="participants-count">
            <span>TOTAL PARTICIPANTS</span>
            <strong>{participants.length}</strong>
          </div>
        </header>

        {/* DRAW BOARD */}
        <main className="luckydraw-board">
          <div className="luckydraw-grid">
            {loading ? (
              <div className="luckydraw-loading">Loading participants...</div>
            ) : error ? (
              <div className="luckydraw-loading">{error}</div>
            ) : (
              boxes.map((user, index) => {
                if (!user) {
                  return (
                    <div className="lucky-box empty" key={index}>
                      <span className="box-number">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                    </div>
                  );
                }

                const isActive = index === activeIndex;

                const isWinner = winner && index === activeIndex;

                return (
                  <div
                    key={`${user.mobile}-${index}`}
                    className={`
                      lucky-box
                      ${isActive ? "active" : ""}
                      ${isWinner ? "winner" : ""}
                    `}
                  >
                    {/* NAME */}
                    <h3>{user.first_name}</h3>

                    {/* MOBILE */}
                    <p>{formatMobile(user.mobile)}</p>
                  </div>
                );
              })
            )}
          </div>

          {/* DRAW ACTION */}
          <div className="draw-actions">
            {!winner && (
              <button
                className="start-draw-btn"
                onClick={startLuckyDraw}
                disabled={drawing || loading || participants.length === 0}
              >
                <span className="button-icon">{drawing ? "◌" : "✦"}</span>

                {drawing ? "Drawing in Progress..." : "Start Lucky Draw"}
              </button>
            )}

            {winner && !drawing && (
              <button className="reset-btn" onClick={resetDraw}>
                Draw Again
              </button>
            )}
          </div>
        </main>

        {/* FOOTER INFO */}
        <div className="draw-footer">
          <span>POWER TEX</span>

          <span className="footer-divider">•</span>

          <span>Fair Random Selection</span>

          <span className="footer-divider">•</span>

          <span>{participants.length} Participants</span>
        </div>
      </div>
    </section>
  );
};

export default LuckyDraw;
